// extracted by mini-css-extract-plugin
export default {"title":"NotFound_title__f917b","description":"NotFound_description__DchP8"};